<template lang="pug">

  transition(
    @enter="enter"
    @leave="leave"
    appear 
    )

    #unsupported
      .landing-title-container
        h1 This simulator is not supported on Internet Explorer. To experience the simulator, please try it on Google Chrome, Safari, Firefox or Microsoft Edge.

</template>

<script>

import gsap from 'gsap'
import { PATHS } from 'src/config/app' 

export default {

  name: PATHS.UNSUPPORTED,

  components: { },

  mixins: [],

  data() {
    return { }
  },

  computed: {},

  mounted() {},

  beforeDestroy() {},

  methods: {

    enter(el, done){
      done()

      // gsap.to(el, { 
      //   duration: 2 * this.motion_clamp,
      //   opacity: 1, 
      //   ease: 'power3.inOut' 
      // }) 
      gsap.set(document.getElementById('pre-loading-section'), { 
        opacity: 0 
      })
      window.debugger
    }, 

    leave(el, done){
      done()
    }
  },

  watch: {},

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#unsupported 
  +full()
  +flex-center() 
  //opacity: 0

  .landing-title-container
    position: absolute
    width: 36vw
    left: 10vw
    bottom: 10vw

    h1
      color: white
      font-family: "CondensedBold"
      text-align: left
      font-size: 2vw
      line-height: 1.5
      text-shadow: 0px 0px 2.5vh rgba(42, 45, 102, 0.8)

</style>
